var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.nots.length > 0),expression:"nots.length > 0"}],staticStyle:{"position":"absolute","bottom":"10px","right":"50px","width":"60px","height":"60px"},attrs:{"type":"primary","circle":""},on:{"click":_vm.test}},[_vm._v("清除")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }